import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/** PROMPT 49 (estabilidad): banner global que aparece mientras el backend no
 * responde (deploy en curso, reinicio, o un 520 transitorio de Cloudflare) en
 * vez de que cada pantalla muestre su propio error crudo. Se alimenta de los
 * eventos que dispara el interceptor de `lib/api.js`. */
export default function ConnectionBanner() {
  const [caido, setCaido] = useState(false);

  useEffect(() => {
    const onDown = () => setCaido(true);
    const onUp = () => setCaido(false);
    window.addEventListener("tny:backend-down", onDown);
    window.addEventListener("tny:backend-up", onUp);
    return () => {
      window.removeEventListener("tny:backend-down", onDown);
      window.removeEventListener("tny:backend-up", onUp);
    };
  }, []);

  if (!caido) return null;

  return (
    <div
      data-testid="connection-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 shadow-md"
    >
      <RefreshCw className="h-4 w-4 animate-spin" />
      El sistema se está reiniciando, reintentando la conexión…
    </div>
  );
}
